import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "href", "icon", "onClick"];
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import O2Icon from "./o2-icon";

function O2PopoverUserAction(props) {
  var children = props.children,
      className = props.className,
      href = props.href,
      icon = props.icon,
      onClick = props.onClick,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var onClickWrapper = function onClickWrapper(e) {
    e.preventDefault();

    if (props.disabled) {
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  var classes = classNames(className, "o2-popover__user-action");
  var content;

  if (icon) {
    if (children && typeof children !== "string") {
      throw new Error("If icon property is specified, children must be string");
    }

    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(O2Icon, {
      name: icon,
      className: "o2-popover__user-action-icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "o2-popover__user-action-text"
    }, children));
  } else {
    content = children;
  }

  return /*#__PURE__*/React.createElement("a", _extends({
    href: href || "#"
  }, attributes, {
    className: classes,
    onClick: onClickWrapper
  }), content);
}

O2PopoverUserAction.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string
};
export default O2PopoverUserAction;